import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { postWithOutToken, getData, patchData,  getDatawithToken, postDatawithToken, postData } from '../../Helpers/ApiMethodHelper';
import CryptoJS from 'crypto-js';
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { axiosPrivate } from '../../Helpers/axios';

function* loginResponse({ payload: { data } }) {
  try {
    const response = yield call(postWithOutToken, '/auth/login', data);
    if (response.status === 200) {
      const passPhrase = "AeS5wL6J7N2nQr5U8x/A?D(G+KbPeShV";
      const bytes = CryptoJS.AES.decrypt(response.data.token, passPhrase);
      const encryptedToken = bytes.toString(CryptoJS.enc.Utf8);
      let decodedToken = jwtDecode(encryptedToken);
      console.log("decode token  ", decodedToken)
      const encryptedData = CryptoJS.AES.encrypt(JSON.stringify({ role: decodedToken.role, role_id: decodedToken.roleId, permissions: decodedToken.permissions }), process.env.REACT_APP_ENCRYPTED_KEY).toString();
      // Store the encrypted data in local storage
      localStorage.setItem('module_access', encryptedData);
      localStorage.setItem('access_token', response.data.token);
      // Cookies.set("biller_access", response.data.token, { expires: 20 / 24 });
      if (!decodedToken.isTwoFactorAuthenticationEnabled) {
        const responseList = yield call(getDatawithToken, '/auth/setup/2fa', response.data.token);
        if (responseList.status === 200) {
          yield put(actions.loginSuccess(responseList.data));
        }
      } else {
        yield put(actions.loginSuccess(response.data));
      }
    } else {
      yield put(actions.loginFailed(response.message));
    }
  } catch (error) {
    console.log(error)
    yield put(actions.loginFailed(error));

  }
}

function* getProfileResponse() {
  try {
    const response = yield call(getData, '/users/me');
    if (response.status === 200) {
      yield put(actions.getProfileSuccess(response.data));
    } else {
      yield put(actions.getProfileFailed(response.message));
    }
  } catch (error) {
    yield put(actions.getProfileFailed(error));
    if(error === "Session timeout. Please login again" || error === "Access token expired or invalid"){
      // Remove token from cookies storage
      sessionStorage.removeItem('biller_access');
      localStorage.removeItem('module_access')
      // Redirect to login page
      window.location.href = '/login';
    }
  }
}

function* agentInfoResponse( { payload: { agentId } } )
{
  console.log("agentidddddddd", agentId)
  try {
    const response = yield call(
      axiosPrivate,
      `/cou-dashboard/getAgentDetails/${agentId}`
    );
    
    if (response.status === 200 || response.status === 201) {
      yield put(actions.getAgentInfoSuccess(response.data));
    } else {
      yield put(actions.getAgentInfoFailed(response));
    }
  } catch (error) {
    yield put(actions.getAgentInfoFailed(error?.response?.data));
  }
}


function* VerifyCodeResponse({ payload: { data, verify } }) {
  const token = localStorage.getItem('access_token');
  try {

    if (verify) {
      const response = yield call(getDatawithToken, '/auth/validate/2fa', token);
      if (response.status === 200) {
        const responseList = yield call(postDatawithToken, '/auth/verify/2fa', token, data);
        if (responseList.status === 200) {
          yield put(actions.verifyCodeSuccess(responseList.data));
          sessionStorage.setItem("biller_access", token);
          localStorage.removeItem('access_token')
          window.location.href = '/';
        } else {
          yield put(actions.verifyCodeFailed(response.message));
        }
      } else {
        yield put(actions.verifyCodeFailed(response.message));
      }
    }
    else {
      const responseList = yield call(postDatawithToken, '/auth/verify/2fa', token, data);
      if (responseList.status === 200) {
        yield put(actions.verifyCodeSuccess(responseList.data));
        sessionStorage.setItem("biller_access", token);
        localStorage.removeItem('access_token')
        window.location.href = '/';
      } else {
        yield put(actions.verifyCodeFailed(responseList.message));
      }
    }

  } catch (error) {
    yield put(actions.verifyCodeFailed(error));

  }
}

function* changePasswordResponse({ payload: { data } }) {
  try {
    const response = yield call(patchData, '/users/change-password', data);
    if (response.status === 200) {
      yield put(actions.changePasswordSuccess("Password updated succcessfully"));
    } else {
      yield put(actions.changePasswordFailed(response.message));
    }
  } catch (error) {
    yield put(actions.changePasswordFailed(error));

  }
}

function* forgotPassword({ payload: { data } }) {
  try {
    const response = yield call(postWithOutToken, '/auth/forgot-password', data);
    if (response && response.status === 200) {
      yield put(actions.forgotPasswordSuccess(response.data))
    } else {
      yield put(actions.forgotPasswordFailed(response || 'unknown error'))
    }
  } catch (error) {
    yield put(actions.forgotPasswordFailed(error || 'unknown error'))
  }
}

function* resetPassword({ payload: { data } }) {
  try {
    const response = yield call(postWithOutToken, `/auth/reset-password?token=${data?.token}`, data?.values);
    if (response && response.status === 200) {
      yield put(actions.resetPasswordSuccess(response.data))
    } else {
      yield put(actions.resetPasswordFailed(response))
    }
  } catch (error) {
    yield put(actions.resetPasswordFailed(error))
  }
}


export default function* rootSaga() {
  yield all( [ takeEvery( actions.LOGIN, loginResponse ) ] );
  yield  all ([ takeEvery(actions.GET_AGENT_INFO, agentInfoResponse)])
  yield all([takeEvery(actions.GET_PROFILE, getProfileResponse)]);
  yield all([takeEvery(actions.CHANGE_PASSWORD, changePasswordResponse)]);
  yield all([takeEvery(actions.VERIFY_CODE, VerifyCodeResponse)]);
  yield all([takeEvery(actions.FORGOT_PASSWORD, forgotPassword)])
  yield all([takeEvery(actions.RESET_PASSWORD, resetPassword)])
}
